import AGGridColumn from "@/utils/UIConstants/AGGridColumns/AGGridColumn.ts";
import {ColDef, ICellRendererParams} from "ag-grid-community";
import AGGridColumnTemplate from "@/utils/UIConstants/AGGridColumns/AGGridColumnTemplate.ts";
import {ExtraDisplayColumnMethodOptions} from "@/utils/common/ListViewUtils.ts";

export default class AGGridAttachmentColumn extends AGGridColumn {
  constructor(column: namaTypes.ListScreenColumn, entityType: string) {
    super(column, entityType);
  }

  override createColDef(extraOptions: ExtraDisplayColumnMethodOptions): ColDef {
    let colDef = AGGridColumn.defaultColDef(this.column, this.entityType, extraOptions.layout);
    colDef.cellRenderer = this.cellRenderer();
    return colDef;
  }

  cellRenderer(): any {
    return (params: ICellRendererParams) => {
      let attachment = params.value;
      if (!attachment || !attachment["attachmentInfo"])
        return '';
      let info: namaTypes.DTOFileAttachmentInfo = attachment["attachmentInfo"];
      return AGGridColumnTemplate.attachmentTemplate(info.fileId!, this.entityType, info.fileName!);
    }
  }
}
